import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UsuarioLog } from 'src/app/models/login/usuarioLog';
import { LoginService } from 'src/app/services/login/login.services';
import Swal from 'sweetalert2';
import { BannerService } from '../../services/administrador/banner.service';

declare var $: any;

@Component({
  selector: 'app-nav-bar-usuario',
  templateUrl: './nav-bar-usuario.component.html',
  styleUrls: ['./nav-bar-usuario.component.css']
})
export class NavBarUsuarioComponent implements OnInit {
  letra = 15;
  log = '';
  grises = false;
  cont = 0;
  usuario: UsuarioLog = {
    nombre: '',
    apellido: '',
    num: 0,
    dependencia: '',
    regional: '',
  }
  inciales = ''
  constructor(private router: Router,
    private loginService: LoginService,
    private bannerService: BannerService) {
    this.log = localStorage.getItem('us');
    this.usuario = this.loginService.gettUsuario();
    this.usuario.apellido = localStorage.getItem('apellido');
    this.usuario.nombre = localStorage.getItem('nombre');
    this.usuario.num = localStorage.getItem('num');
    this.usuario.dependencia = localStorage.getItem('dependencia');
    this.usuario.regional = localStorage.getItem('regional');
    this.inciales = (this.usuario.nombre.charAt(0) + this.usuario.apellido.charAt(0)).toUpperCase();
  }
  normal() {
    $('#aumento').attr("href", "assets/css/sinAumento.css")
    this.cont = 0;
  }
  aumentar() {
    if (this.cont == 0) {
      $('#aumento').attr("href", "assets/css/aumento1.css")
      this.cont = 1;
      return
    }
    if (this.cont == 1) {
      $('#aumento').attr("href", "assets/css/aumento2.css")
      this.cont = 2;

      return
    }
    if (this.cont == 2) {
      $('#aumento').attr("href", "assets/css/aumento3.css")

      return
    }

  }
  disminuir() {
    if (this.cont == 0) {
      $('#aumento').attr("href", "assets/css/disminuir.css")
      return
    }
    if (this.cont == 1) {
      $('#aumento').attr("href", "assets/css/sinAumento.css")
      console.log('entro')
      this.cont = 0;
      return
    }
    if (this.cont == 2) {
      $('#aumento').attr("href", "assets/css/aumento1.css")
      this.cont = 1;
      return
    }
  }
  cambiar() {
    if (this.grises) {
      $('#estilos').attr("href", "assets/css/normal.css")
      $('#logoSen').attr("src", "../../../../assets/img/icons/iconSena.png")
      $('#noti1').attr("src", "../../../../assets/img/home/pueblos.png")
      this.grises = false;
      this.bannerService.grises = false;
    }
    else {
      $('#estilos').attr("href", "assets/css/grises.css")
      $('#logoSen').attr("src", "../../../../assets/img/icons/iconoNegro.png")
      $('#noti1').attr("src", "../../../../assets/img/home/pueblosGrises.png")
      this.grises = true;
      this.bannerService.grises = true;
    }
  }
  salir() {

    localStorage.setItem('us', 'No');
    this.router.navigate(['/inicio']);
    sessionStorage.clear();
    localStorage.clear();
    localStorage.setItem('municipio', '')
  }
  ngOnInit(): void {
  }

  enfocar() {
    document.getElementById("idFocus").focus();
  }

  mostrarAlerta(nombre: string, url: string, target: string) {
    Swal.fire({
      title: 'Redireccionamiento',
      text: "Usted está a punto de ingresar a un sitio externo de la sede electrónica del SENA. "
        + "A partir de este momento es responsabilidad de " + nombre + " el cumplimiento de las normas que regulan su relación. "
        + "Cualquier solicitud deberá ser dirigida al responsable de dicho sitio " + nombre + ". ¿Desea ingresar al sitio?",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#E56000',
      cancelButtonColor: '#E56000',
      cancelButtonText: 'No',
      confirmButtonText: 'Si'
    }).then((result) => {
      if (result.isConfirmed) {
        const anchor = document.createElement('a');
        anchor.href = url;
        anchor.target = target;
        anchor.click();
      }
    });
  }

}
